import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { Link } from 'react-router-dom';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuy.courses';

const articleCards = [
  {
    slug: '/what-is-superbuy-spreadsheet/',
    tag: 'Guide',
    tagClass: 'text-primary-600 bg-primary-50',
    title: 'What Is a Superbuy Spreadsheet?',
    excerpt: 'Learn everything about superbuy spreadsheets — how they work, why you need one, and how to use them effectively for your shopping.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20dark%20wooden%20desk%20displaying%20colorful%20spreadsheet%20with%20fashion%20product%20thumbnails%2C%20warm%20desk%20lamp%20glow%20creating%20cozy%20evening%20atmosphere%2C%20cozy%20home%20office%20setup%20with%20indoor%20plants%2C%20editorial%20tech%20lifestyle%20photography%20with%20inviting%20warm%20tones&width=800&height=500&seq=article-v2-card-01&orientation=landscape',
    readTime: '10 min',
  },
  {
    slug: '/best-superbuy-spreadsheet-beginners/',
    tag: 'Beginners',
    tagClass: 'text-emerald-700 bg-emerald-50',
    title: 'Best Superbuy Spreadsheet for Beginners',
    excerpt: 'New to Superbuy? Start here with our beginner-friendly guide covering everything from account setup to placing your first order with confidence.',
    image: 'https://readdy.ai/api/search-image?query=Young%20person%20happily%20unboxing%20fashion%20sneakers%20on%20bright%20white%20desk%20with%20natural%20sunlight%20streaming%20in%2C%20beginner%20excitement%20and%20discovery%20moment%2C%20clean%20modern%20apartment%20interior%2C%20lifestyle%20editorial%20photography%20with%20fresh%20energetic%20feel&width=800&height=500&seq=article-v2-card-02&orientation=landscape',
    readTime: '8 min',
  },
  {
    slug: '/how-to-use-superbuy-spreadsheet/',
    tag: 'Tutorial',
    tagClass: 'text-accent-700 bg-accent-100',
    title: 'How to Use a Superbuy Spreadsheet',
    excerpt: 'Step-by-step tutorial on navigating and maximizing your superbuy spreadsheet. Tips, tricks, and best practices from experienced shoppers.',
    image: 'https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20hands%20typing%20on%20silver%20laptop%20next%20to%20notebook%20with%20handwritten%20notes%20and%20coffee%20cup%2C%20organized%20desk%20setup%20with%20modern%20stationery%2C%20bright%20natural%20daylight%20from%20window%2C%20productivity%20lifestyle%20photography%20with%20clean%20aesthetic&width=800&height=500&seq=article-v2-card-03&orientation=landscape',
    readTime: '9 min',
  },
  {
    slug: '/superbuy-spreadsheet-save-money/',
    tag: 'Tips',
    tagClass: 'text-amber-700 bg-amber-50',
    title: 'Why Superbuy Spreadsheets Save Money',
    excerpt: 'Discover how using a curated superbuy spreadsheet can cut your shopping costs significantly. Real price comparisons and money-saving strategies.',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20coins%20and%20shopping%20bags%20on%20wooden%20surface%20with%20warm%20golden%20sunlight%2C%20financial%20savings%20concept%20photography%2C%20cozy%20home%20environment%20with%20soft%20bokeh%20background%2C%20editorial%20lifestyle%20photography%20with%20hopeful%20prosperous%20atmosphere&width=800&height=500&seq=article-v2-card-04&orientation=landscape',
    readTime: '7 min',
  },
  {
    slug: '/best-sneaker-superbuy-spreadsheet/',
    tag: 'Sneakers',
    tagClass: 'text-red-700 bg-red-50',
    title: 'Best Sneaker Superbuy Spreadsheet 2026',
    excerpt: 'The ultimate guide to finding the best sneaker deals. From Nike to Jordan to Yeezy, we cover every major brand with verified seller sources.',
    image: 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20colorful%20designer%20sneakers%20displayed%20on%20white%20minimalist%20shelves%20against%20concrete%20wall%2C%20urban%20streetwear%20aesthetic%2C%20bold%20vibrant%20colors%20with%20dramatic%20gallery%20lighting%2C%20luxury%20sneaker%20editorial%20photography%20with%20cool%20industrial%20backdrop&width=800&height=500&seq=article-v2-card-05&orientation=landscape',
    readTime: '11 min',
  },
  {
    slug: '/best-clothing-superbuy-spreadsheet/',
    tag: 'Clothing',
    tagClass: 'text-indigo-700 bg-indigo-50',
    title: 'Best Clothing Superbuy Spreadsheet',
    excerpt: 'From hoodies to jackets to streetwear essentials — our comprehensive clothing category guide with the most trusted seller recommendations.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20clothing%20rack%20with%20curated%20selection%20of%20earth%20tone%20jackets%20hoodies%20and%20shirts%20in%20bright%20airy%20loft%20space%2C%20boutique%20retail%20display%20aesthetic%2C%20natural%20daylight%20with%20soft%20shadows%2C%20fashion%20editorial%20photography%20with%20refined%20contemporary%20style&width=800&height=500&seq=article-v2-card-06&orientation=landscape',
    readTime: '10 min',
  },
  {
    slug: '/designer-brands-superbuy-spreadsheet/',
    tag: 'Luxury',
    tagClass: 'text-purple-700 bg-purple-50',
    title: 'Designer Brands Superbuy Spreadsheet',
    excerpt: 'Luxury fashion on a budget — our curated list of designer brands and premium sellers for those who want quality without the retail markup.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20designer%20handbag%20and%20luxury%20watch%20displayed%20on%20dark%20marble%20surface%20with%20gold%20accents%2C%20high%20end%20accessories%20flat%20lay%2C%20dramatic%20spotlight%20lighting%20with%20rich%20shadows%2C%20luxury%20editorial%20product%20photography%20with%20sophisticated%20opulent%20atmosphere&width=800&height=500&seq=article-v2-card-07&orientation=landscape',
    readTime: '12 min',
  },
  {
    slug: '/superbuy-shipping-guide/',
    tag: 'Shipping',
    tagClass: 'text-cyan-700 bg-cyan-50',
    title: 'Superbuy Shipping Guide 2026',
    excerpt: 'Everything you need to know about Superbuy shipping — methods, costs, delivery times, and how to track your packages internationally.',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20packaging%20materials%20neatly%20arranged%20on%20light%20wood%20table%20with%20world%20map%20in%20background%2C%20global%20logistics%20concept%2C%20bright%20organized%20workspace%2C%20professional%20commercial%20photography%20with%20clean%20orderly%20composition&width=800&height=500&seq=article-v2-card-08&orientation=landscape',
    readTime: '9 min',
  },
  {
    slug: '/reduce-superbuy-shipping-costs/',
    tag: 'Savings',
    tagClass: 'text-orange-700 bg-orange-50',
    title: 'How to Reduce Superbuy Shipping Costs',
    excerpt: 'Practical strategies to minimize your Superbuy shipping expenses. Learn about consolidation, packaging choices, and carrier comparisons.',
    image: 'https://readdy.ai/api/search-image?query=Calculator%20and%20receipt%20papers%20with%20handwritten%20savings%20notes%20on%20warm%20wooden%20desk%2C%20financial%20planning%20workspace%20aesthetic%2C%20soft%20morning%20sunlight%20through%20sheer%20curtains%2C%20cozy%20home%20office%20photography%20with%20mindful%20budget%20conscious%20atmosphere&width=800&height=500&seq=article-v2-card-09&orientation=landscape',
    readTime: '8 min',
  },
  {
    slug: '/superbuy-agent-comparison-guide/',
    tag: 'Comparison',
    tagClass: 'text-teal-700 bg-teal-50',
    title: 'Superbuy Agent Comparison Guide',
    excerpt: 'Side-by-side comparison of popular shopping agents. How Superbuy stacks up against alternatives for pricing, service, and reliability.',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20on%20dark%20desk%20displaying%20comparison%20apps%20with%20colorful%20interface%20screens%2C%20split%20screen%20technology%20concept%2C%20modern%20tech%20workspace%20with%20ambient%20neon%20glow%2C%20contemporary%20digital%20lifestyle%20photography%20with%20sleek%20futuristic%20vibe&width=800&height=500&seq=article-v2-card-10&orientation=landscape',
    readTime: '11 min',
  },
  {
    slug: '/superbuy-safety-guide/',
    tag: 'Safety',
    tagClass: 'text-secondary-700 bg-secondary-100',
    title: 'Superbuy Safety Guide: Shop Secure',
    excerpt: 'Stay safe while shopping. Our comprehensive guide covers payment protection, scam prevention, and trusted seller verification methods.',
    image: 'https://readdy.ai/api/search-image?query=Padlock%20icon%20hologram%20floating%20above%20smartphone%20screen%20on%20dark%20wooden%20desk%2C%20cybersecurity%20and%20online%20shopping%20safety%20concept%2C%20dimly%20lit%20modern%20home%20office%20with%20blue%20ambient%20glow%2C%20technology%20security%20editorial%20photography%20with%20protective%20trustworthy%20mood&width=800&height=500&seq=article-v2-card-11&orientation=landscape',
    readTime: '12 min',
  },
  {
    slug: '/superbuy-faq/',
    tag: 'FAQ',
    tagClass: 'text-rose-700 bg-rose-50',
    title: 'Superbuy FAQ: Common Questions',
    excerpt: 'Answers to the most frequently asked questions about Superbuy — from account setup to ordering, shipping, returns, and everything in between.',
    image: 'https://readdy.ai/api/search-image?query=Question%20mark%20shaped%20sticky%20notes%20on%20cork%20board%20with%20colorful%20tabs%20and%20pushpins%20in%20organized%20creative%20workspace%2C%20knowledge%20and%20learning%20concept%2C%20bright%20airy%20modern%20office%20with%20natural%20daylight%2C%20editorial%20photography%20with%20warm%20helpful%20atmosphere&width=800&height=500&seq=article-v2-card-12&orientation=landscape',
    readTime: '7 min',
  },
];

export default function Home() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Superbuy Spreadsheet",
          "url": siteUrl,
          "description": "Best superbuy spreadsheet resource for fashion, sneakers, and streetwear. Trusted seller guides and curated category spreadsheets.",
          "sameAs": [
            "https://kaspreadsheet.com/"
          ]
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Superbuy Spreadsheet",
          "url": siteUrl,
          "description": "Best superbuy spreadsheet resource for fashion, sneakers, and streetwear. Trusted seller guides and curated category spreadsheets.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${siteUrl}/search?q={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": siteUrl
            }
          ]
        })}
      </script>
    <main>
      <Navbar />
      <HeroSection />

      <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/50 overflow-hidden">
              <div className="aspect-[4/3] -mx-8 -mt-8 mb-6 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Verified%20badge%20and%20checklist%20hologram%20overlay%20on%20modern%20smartphone%20screen%20with%20shopping%20app%20interface%2C%20digital%20trust%20and%20verification%20concept%2C%20clean%20tech%20aesthetics%20with%20soft%20blue%20ambient%20lighting%2C%20professional%20product%20photography%20with%20futuristic%20trustworthy%20atmosphere&width=600&height=450&seq=feature-card-v2-01&orientation=landscape"
                  alt="Verified Sellers"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-primary-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">Verified Sellers</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">Every seller in our superbuy spreadsheet is manually verified for quality, reliability, and customer satisfaction.</p>
            </div>
            <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/50 overflow-hidden">
              <div className="aspect-[4/3] -mx-8 -mt-8 mb-6 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Calendar%20with%20red%20circled%20dates%20and%20refresh%20arrows%20on%20clean%20white%20desk%20with%20modern%20planner%20and%20pen%2C%20weekly%20update%20scheduling%20concept%2C%20bright%20organized%20workspace%20with%20natural%20daylight%2C%20editorial%20productivity%20photography%20with%20fresh%20dynamic%20energy&width=600&height=450&seq=feature-card-v2-02&orientation=landscape"
                  alt="Updated Weekly"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-14 h-14 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-refresh-line text-accent-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">Updated Weekly</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">Our superbuy spreadsheet 2026 is refreshed regularly with new sellers, updated prices, and the latest category additions.</p>
            </div>
            <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/50 overflow-hidden">
              <div className="aspect-[4/3] -mx-8 -mt-8 mb-6 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Team%20of%20diverse%20fashion%20experts%20reviewing%20fabric%20samples%20and%20trend%20boards%20around%20modern%20white%20conference%20table%2C%20collaborative%20creative%20workspace%20with%20natural%20daylight%2C%20professional%20editorial%20photography%20with%20warm%20inclusive%20atmosphere%20and%20focused%20energy&width=600&height=450&seq=feature-card-v2-03&orientation=landscape"
                  alt="Expert Curated"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-14 h-14 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-secondary-700 text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">Expert Curated</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">Backed by 5+ years of cross-border shopping experience, our team handpicks the best superbuy spreadsheet resources.</p>
            </div>
          </div>
        </div>
      </section>

      <CategoryGrid />

      <AboutSection />

      <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
            <div>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                Latest Superbuy Spreadsheet Guides
              </h2>
              <p className="text-foreground-600 text-base md:text-lg font-light max-w-xl">
                Expert articles to help you get the most out of your superbuy spreadsheet experience
              </p>
            </div>
            <Link
              to="/what-is-superbuy-spreadsheet/"
              className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap flex items-center gap-1"
            >
              View all guides
              <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articleCards.map((article, idx) => (
              <article key={idx} className="bg-background-100 rounded-xl overflow-hidden border border-background-200/50 group cursor-pointer">
                <Link to={article.slug} className="block">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={`${article.title} - Superbuy Spreadsheet`}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5 md:p-6">
                    <span className={`text-xs font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full ${article.tagClass}`}>
                      {article.tag}
                    </span>
                    <h3 className="text-lg font-heading font-bold text-foreground-950 mt-3 mb-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/50">
                      <span className="text-xs text-foreground-500">{article.readTime} read</span>
                      <span className="text-xs text-foreground-500">&middot;</span>
                      <span className="text-xs text-foreground-500">Updated 2026</span>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <TestimonialSection />
      <CTASection />
      <Footer />
    </main>
    </>
  );
}